import { atom } from 'jotai';

export interface BreakdownFilter {
  field: string;
  key: null;
  op: string;
  value: string;
  display: string;
  originalField: string;
}

export const breakdownFiltersAtom = atom<BreakdownFilter[]>([]);
export const breakdownModalVisibleAtom = atom<boolean>(false);
import { USAGE_TYPE_ALL, USAGE_TYPE_MCP_ONLY, USAGE_TYPE_API_ONLY } from './constants';

export type UsageTypeFilter =
  | typeof USAGE_TYPE_ALL
  | typeof USAGE_TYPE_MCP_ONLY
  | typeof USAGE_TYPE_API_ONLY;
export const usageTypeFilterAtom = atom<UsageTypeFilter>(USAGE_TYPE_ALL);
export const breakdownChartOrderAtom = atom<string[]>([]);
export const breakdownTableOrderAtom = atom<string[]>([]);
